import http from "@/http-common";

/* eslint-disable */
class AdminInfoDataService {

    getAreaInfo(): Promise<any>{
        return http.api.post("/getAreaData/");
    }

    getCountryInfo(): Promise<any>{
        return http.api.post("/getCountryData/");
    }

    insertOrUpdateStationInfo(data : any): Promise<any>{
        return http.api.post("/insertOrUpdateStationInfo/", data);
    }

    updateStationData(data : any): Promise<any>{
        return http.api.post("/updateStationData/", data);
    }

    getNewsAdmin(data: any): Promise<any>{
        return http.api.post("/getNewsAdmin/", data);
    }

    getUserByUserID(data: any): Promise<any>{
        return http.api.post("/getUserByUserID/", data);
    }

    addNewsAdmin(data: any): Promise<any>{
        return http.api.post("/addNewsAdmin/", data);
    }

    deleteNewsAdmin(data: any): Promise<any>{
        return http.api.post("/deleteNewsAdmin/", data);
    }
}

export default new AdminInfoDataService();
